import { DateTime } from 'luxon';

import { loadLuxonDateTime, notNull } from '@rygen/rygen-ui/util';

export class CarrierPickupAvailabilityOptions {
  availablePickupDate?: DateTime;
  availableEarliestPickupTimes: DateTime[] = [];
  availableLatestPickupTimes: DateTime[] = [];
  cutoffTime?: DateTime;

  constructor(opts?: Partial<CarrierPickupAvailabilityOptions>) {
    if (opts?.availablePickupDate != null) {
      this.availablePickupDate = loadLuxonDateTime(opts.availablePickupDate);
    }
    if (opts?.cutoffTime != null) {
      this.cutoffTime = loadLuxonDateTime(opts.cutoffTime);
    }
    if (opts?.availableEarliestPickupTimes != null) {
      this.availableEarliestPickupTimes = opts.availableEarliestPickupTimes
        .map((val) => loadLuxonDateTime(val))
        .filter(notNull);
    }
    if (opts?.availableLatestPickupTimes != null) {
      this.availableLatestPickupTimes = opts.availableLatestPickupTimes
        .map((val) => loadLuxonDateTime(val))
        .filter(notNull);
    }
  }
}
